var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle-scale"},_vm._l((_vm.count),function(index){return _c('div',{key:index,staticClass:"circle-scale-item",class:{active: index <= _vm.position}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }